import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { clsx } from 'clsx';
import { useAtom } from 'jotai';
import ascIcon from '@web/utils/src/assets/icons/functions/asc-icon.svg';
import cardViewIcon from '@web/utils/src/assets/icons/functions/card-view-icon.svg';
import filterIcon from '@web/utils/src/assets/icons/functions/filter-icon.svg';
import listViewIcon from '@web/utils/src/assets/icons/functions/list-view-icon.svg';
import { isInventoryListAtom } from '@/store/atoms';

const InventorySorting = () => {
  const [isAsc, setIsAsc] = React.useState(false);
  const [isList, setList] = useAtom(isInventoryListAtom);
  const { t } = useTranslation();

  return (
    <div className="flex md:justify-between justify-end py-3-0 md:py-2-0">
      <p className="hidden md:block text-1-2 w-1/2">
        {t('retailer.sorting_title')}
      </p>
      <div className="flex w-full md:w-auto">
        <div className="md:hidden flex items-center">
          <p className="text-2-2 font-bd mr-2-0">{t('retailer.filter')}</p>
          <img src={filterIcon} alt={t('retailer.filter') || 'Filter'} />
        </div>
        <div className="flex items-center mr-5-0 ml-auto">
          <div className="hidden md:block mr-1-5 font-bd text-2-2 md:text-1-2">
            {t('retailer.view')}
          </div>
          <div className="md:hidden text-2-2 font-bd mr-3-0">
            {t('retailer.sort')}
          </div>
          <img
            src={cardViewIcon}
            alt="Grid"
            className={clsx(isList && 'opacity-30', 'mr-1-0')}
            onClick={() => setList(false)}
          />
          <img
            src={listViewIcon}
            alt="List"
            className={clsx(!isList && 'opacity-30')}
            onClick={() => setList(true)}
          />
        </div>
        <div className="flex items-center">
          <div className="hidden md:block mr-1-5 font-bd text-2-2 md:text-1-2">
            {t('retailer.relevance')}
          </div>
          <img
            src={ascIcon}
            alt="Descending"
            className={clsx(
              isAsc && 'opacity-30',
              'mr-1-0 rotate-180 transform',
            )}
            onClick={() => setIsAsc(true)}
          />
          <img
            src={ascIcon}
            alt="Ascending"
            className={clsx(!isAsc && 'opacity-30')}
            onClick={() => setIsAsc(true)}
          />
        </div>
      </div>
    </div>
  );
};

export default InventorySorting;
